import store from '@/store'
import find from 'lodash/find'

const ApplicationValidation = {

  methods: {
    isValidStateChange(id,data) {
      const state = find(store.getters['basic/basicApplicationStates'], ['id',id])
      const requiredFields = {
        draft: ['personalNumber','stateId'],
        confirmedByStudent: ['id','personalNumber','stateId','firstName','lastName','address1','zip','city','country','email','mobilephone'],
        confirmedByCompany: ['id','companyId','instructorId','professionId','employmentDate','employmentTypeId'],
        confirmedAndApprovedByCompany: ['id','personalNumber','stateId','firstName','lastName','address1','zip','city','country','email','mobilephone','companyId','instructorId','professionId','employmentDate','employmentTypeId'],
        approved: ['id','personalNumber','stateId','firstName','lastName','address1','zip','city','country','email','mobilephone','companyId','instructorId','professionId','employmentDate','employmentTypeId'],
        ordered: ['id','personalNumber','stateId','firstName','lastName','address1','zip','city','country','email','mobilephone','companyId','instructorId','professionId','employmentDate','employmentTypeId'],
        closed: ['id']
      }
      if (!(state && state.state && requiredFields[state.state])) return false

      let ok = true
      requiredFields[state.state].forEach(field => {
        ok = ok === false ? false : Boolean(data[field] && (Boolean(data[field]) || data[field] === 0))
      })
      return ok
    }
  }
}

export default ApplicationValidation